import { environment } from '@env/environment';
import { IMenuElement } from '@interfaces/menu.interface';

export const administratorMenu: IMenuElement[] = [
  {
    label: 'administration',
    text: $localize`Administracja`,
    module: 'administracja',
    isRootElement: true,
    expectedPermissionCode: 'KonfiguracjaUczelni',
    children: [
      {
        label: 'administrationDictionaries',
        text: $localize`Słowniki`,
        module: 'administracja',
        expectedPermissionCode: 'KonfiguracjaUczelni.PlatformaAdministracyjna.Slowniki',
        children: [
          {
            label: 'administrationBuildings',
            text: $localize`Budynki`,
            module: 'administracja',
            expectedPermissionCode: 'KonfiguracjaUczelni.PlatformaAdministracyjna.Slowniki.Budynki.Lista',
            children: null,
          },
          {
            label: 'administrationDefinableFields',
            text: $localize`Pola definiowalne`,
            module: 'administracja',
            expectedPermissionCode:
              'KonfiguracjaUczelni.PlatformaAdministracyjna.Slowniki.DodatkowePolaDefiniowalne.Lista',
            children: null,
          },
          {
            label: 'administrationDidacticCycles',
            text: $localize`Cykle dydaktyczne`,
            module: 'administracja',
            expectedPermissionCode: 'KonfiguracjaUczelni.PlatformaAdministracyjna.Slowniki.CykleDydaktyczne.Lista',
            children: null,
          },
          {
            label: 'administracjaSlownikiGrupyStanowisk',
            text: $localize`Grupy stanowisk`,
            module: 'administracja',
            expectedPermissionCode:
              'KonfiguracjaUczelni.PlatformaAdministracyjna.Pracownicy.Slowniki.GrupyStanowisk.Lista',
            children: null,
          },
          {
            label: 'administrationUnits',
            text: $localize`Jednostki organizacyjne`,
            module: 'administracja',
            expectedPermissionCode:
              'KonfiguracjaUczelni.PlatformaAdministracyjna.Slowniki.JednostkiOrganizacyjne.Lista',
            children: null,
          },
          {
            label: 'administrationStreets',
            text: $localize`Ulice`,
            module: 'administracja',
            expectedPermissionCode: 'KonfiguracjaUczelni.PlatformaAdministracyjna.Slowniki.Ulice',
            children: null,
          },
          {
            label: 'administrationCities',
            text: $localize`Miejscowości`,
            module: 'administracja',
            expectedPermissionCode: 'KonfiguracjaUczelni.PlatformaAdministracyjna.Slowniki.Miejscowosci.Lista',
            children: null,
          },
          {
            label: 'administrationCountries',
            text: $localize`Kraje`,
            module: 'administracja',
            expectedPermissionCode: 'KonfiguracjaUczelni.PlatformaAdministracyjna.Slowniki.Kraje.Lista',
            children: null,
          },
          {
            label: 'administrationCitizenships',
            text: $localize`Obywatelstwa`,
            module: 'administracja',
            expectedPermissionCode: 'KonfiguracjaUczelni.PlatformaAdministracyjna.Slowniki.Obywatelstwa.Lista',
            children: null,
          },
          {
            label: 'administrationGenders',
            text: $localize`Płcie`,
            module: 'administracja',
            expectedPermissionCode: 'KonfiguracjaUczelni.PlatformaAdministracyjna.Slowniki.Plcie.Lista',
            children: null,
          },
          {
            label: 'administrationIDs',
            text: $localize`Rodzaje dokumentów tożsamości`,
            module: 'administracja',
            expectedPermissionCode:
              'KonfiguracjaUczelni.PlatformaAdministracyjna.Slowniki.RodzajeDokumentowTozsamosci.Lista',
            children: null,
          },
          {
            label: 'administrationAcademicYear',
            text: $localize`Lata akademickie`,
            module: 'administracja',
            expectedPermissionCode: 'KonfiguracjaUczelni.PlatformaAdministracyjna.Slowniki.RokAkademicki.Lista',
            children: null,
          },
          {
            label: 'administrationRooms',
            text: $localize`Sale`,
            module: 'administracja',
            expectedPermissionCode: 'KonfiguracjaUczelni.PlatformaAdministracyjna.Slowniki.Sale.Lista',
            children: null,
          },
          {
            label: 'administrationAcademicDegrees',
            text: $localize`Stopnie naukowe`,
            module: 'administracja',
            expectedPermissionCode: 'KonfiguracjaUczelni.PlatformaAdministracyjna.Slowniki.StopnieNaukowe.Lista',
            children: null,
          },
          {
            label: 'administrationColleges',
            text: $localize`Szkoły wyższe`,
            module: 'administracja',
            expectedPermissionCode: 'KonfiguracjaUczelni.PlatformaAdministracyjna.Slowniki.SzkolyWyzsze.Lista',
            children: null,
          },
          {
            label: 'administrationAcademicTitle',
            text: $localize`Tytuły naukowe`,
            module: 'administracja',
            expectedPermissionCode: 'KonfiguracjaUczelni.PlatformaAdministracyjna.Slowniki.TytulyNaukowe.Lista',
            children: null,
          },
          {
            label: 'administrationUniversityTitle',
            text: $localize`Tytuły uczelniane`,
            module: 'administracja',
            expectedPermissionCode: 'KonfiguracjaUczelni.PlatformaAdministracyjna.Slowniki.TytulyUczelniane.Lista',
            children: null,
          },
          {
            label: 'administrationProfessionalTitle',
            text: $localize`Tytuły zawodowe`,
            module: 'administracja',
            expectedPermissionCode: 'KonfiguracjaUczelni.PlatformaAdministracyjna.Slowniki.TytulyZawodowe.Lista',
            children: null,
          },
          {
            label: 'administrationBuildingTypes',
            text: $localize`Typy budynków`,
            module: 'administracja',
            expectedPermissionCode: 'KonfiguracjaUczelni.PlatformaAdministracyjna.Slowniki.TypyBudynkow.Lista',
            children: null,
          },
          {
            label: 'administrationDidacticCyclesTypes',
            text: $localize`Typy cykli dydaktycznych`,
            module: 'administracja',
            expectedPermissionCode:
              'KonfiguracjaUczelni.PlatformaAdministracyjna.Slowniki.TypyCykliDydaktycznych.Lista',
            children: null,
          },
          {
            label: 'administrationUnitsTypes',
            text: $localize`Typy jednostek organizacyjnych`,
            module: 'administracja',
            expectedPermissionCode:
              'KonfiguracjaUczelni.PlatformaAdministracyjna.Slowniki.TypyJednostekOrganizacyjnych.Lista',
            children: null,
          },
          {
            label: 'administrationGettingDegreeModes',
            text: $localize`Tryby nadania stopnia naukowego`,
            module: 'administracja',
            expectedPermissionCode:
              'KonfiguracjaUczelni.PlatformaAdministracyjna.Slowniki.TrybyNadaniaStopniaNaukowego.Lista',
            children: null,
          },
          {
            label: 'administrationRoomTypes',
            text: $localize`Typy sal`,
            module: 'administracja',
            expectedPermissionCode: 'KonfiguracjaUczelni.PlatformaAdministracyjna.Slowniki.TypySal.Lista',
            children: null,
          },
          {
            label: 'administrationForeignLanguages',
            text: $localize`Języki obce`,
            module: 'administracja',
            expectedPermissionCode: 'KonfiguracjaUczelni.PlatformaAdministracyjna.Slowniki.JezykiObce.Lista',
            children: null,
          },
          {
            label: 'administracjaZrodlaFinansowania',
            text: $localize`Źródła finansowania`,
            module: 'administracja',
            expectedPermissionCode:
              'KonfiguracjaUczelni.PlatformaAdministracyjna.Pracownicy.Slowniki.ZrodlaFinansowania.Lista',
            children: null,
          },
          {
            label: 'administracjaFormyZatrudnienia',
            text: $localize`Formy zatrudnienia`,
            module: 'administracja',
            expectedPermissionCode:
              'KonfiguracjaUczelni.PlatformaAdministracyjna.Pracownicy.Slowniki.FormyZatrudnienia.Lista',
            children: null,
          },
          {
            label: 'administracjaCharakteryPracy',
            text: $localize`Charaktery pracy`,
            module: 'administracja',
            expectedPermissionCode:
              'KonfiguracjaUczelni.PlatformaAdministracyjna.Pracownicy.Slowniki.CharakteryPracy.Lista',
            children: null,
          },
          {
            label: 'administracjaRodzajeNiepelnosprawnosci',
            text: $localize`Rodzaje niepełnosprawności`,
            module: 'administracja',
            expectedPermissionCode:
              'KonfiguracjaUczelni.PlatformaAdministracyjna.Slowniki.RodzajeNiepelnosprawnosci.Lista',
            children: null,
          },
          {
            label: 'administrationDisabilityDegrees',
            expectedPermissionCode:
              'KonfiguracjaUczelni.PlatformaAdministracyjna.Slowniki.StopnieNiepelnosprawnosci.Lista',
            text: $localize`Stopnie niepełnosprawności`,
            module: 'administracja',
            children: null,
          },
          {
            label: 'administracjaSymbolePrzyczynNiepelnosprawnosci',
            text: $localize`Symbole przyczyn niepełnosprawności`,
            module: 'administracja',
            expectedPermissionCode:
              'KonfiguracjaUczelni.PlatformaAdministracyjna.Slowniki.SymbolPrzyczynyNiepelnosprawnosci.Lista',
            children: null,
          },
        ],
      },
      {
        label: 'administrationSystem',
        text: $localize`System`,
        module: 'administracja/system',
        expectedPermissionCode: 'Systems',
        children: [
          {
            label: 'administrationSystemAuditedOperations',
            text: $localize`Audytowane operacje`,
            module: 'administracja/system',
            expectedPermissionCode: 'Systems.AudytowanaOperacja',
            children: null,
          },
          {
            label: null,
            text: $localize`Dziennik systemowy`,
            module: null,
            children: null,
            expectedPermissionCode: 'Systems',
            redirectTo: environment.systemLogsUrl,
          },
          {
            label: 'administrationSystemVersions',
            text: $localize`Informacje o systemie`,
            module: 'administracja/system',
            expectedPermissionCode: 'Systems.Wersjonowanie.System',
            children: null,
          },
          {
            label: 'administrationSystemLoginSettings',
            text: $localize`Ustawienia logowań`,
            module: 'administracja/system',
            expectedPermissionCode: 'UserAccess.Ustawienia.Podglad',
            children: null,
          },
          {
            label: 'administrationSystemBasicSettings',
            text: $localize`Ustawienia ogólne`,
            module: 'administracja/system',
            expectedPermissionCode: 'Systems.UstawieniaSystemu',
            children: null,
          },
          {
            label: 'administracjaDziennikPrzetwarzaniaKolejki',
            text: $localize`Dziennik przetwarzania kolejki`,
            module: 'administracja/system',
            expectedPermissionCode: 'Systems',
            children: null,
          },
        ],
      },
      {
        label: 'polonDictionaries',
        text: $localize`POL-on`,
        module: 'administracja',
        expectedPermissionCode: 'Polon',
        children: [
          {
            label: 'polonExports',
            text: $localize`Eksportowanie danych`,
            module: 'administracja/polon',
            expectedPermissionCode: 'Polon.PlatformaAdministracyjna.StudentEksportPaczki.Lista',
            children: [
              {
                label: 'polonStudentsExports',
                text: $localize`Studenci`,
                module: 'administracja/polon',
                expectedPermissionCode: 'Polon.PlatformaAdministracyjna.StudentEksportPaczki.Lista',
                children: null,
              },
            ],
          },
          {
            label: 'polonConfiguration',
            text: $localize`Konfiguracja`,
            module: 'administracja/polon',
            expectedPermissionCode: 'Polon', // ! tymczasowo, backend nie zwraca wlasciwego kodu: Polon.Konfiguracja
            children: [
              {
                label: 'polonFormsOfStudy',
                text: $localize`Formy studiów`,
                module: 'administracja/polon',
                expectedPermissionCode: 'Polon.Konfiguracja.PlatformaAdministracyjna.FormyStudiow.Lista',
                children: null,
              },
              {
                label: 'polonUnits',
                text: $localize`Jednostki`,
                module: 'administracja/polon',
                expectedPermissionCode: 'Polon.Konfiguracja.PlatformaAdministracyjna.Jednostki.Lista',
                children: null,
              },
              {
                label: 'polonCountries',
                text: $localize`Kraje`,
                module: 'administracja/polon',
                expectedPermissionCode: 'Polon.Konfiguracja.PlatformaAdministracyjna.Kraje.Lista',
                children: null,
              },
              {
                label: 'polonCitizenships',
                text: $localize`Obywatelstwa`,
                module: 'administracja/polon',
                expectedPermissionCode: 'Polon.Konfiguracja.PlatformaAdministracyjna.Obywatelstwa.Lista',
                children: null,
              },
              {
                label: 'polonGenders',
                text: $localize`Płcie`,
                module: 'administracja/polon',
                expectedPermissionCode: 'Polon.Konfiguracja.PlatformaAdministracyjna.Plcie.Lista',
                children: null,
              },
              {
                label: 'polonStudyBasics',
                text: $localize`Podstawy studiowania`,
                module: 'administracja/polon',
                expectedPermissionCode: 'Polon.Konfiguracja.PlatformaAdministracyjna.PodstawyStudiowania.Lista',
                children: null,
              },
              {
                label: 'polonStudyPrograms',
                text: $localize`Programy studiów`,
                module: 'administracja/polon',
                expectedPermissionCode: 'Polon.Konfiguracja.PlatformaAdministracyjna.ProgramyStudiow.Lista',
                children: null,
              },
              {
                label: 'polonPracownicy',
                text: $localize`Pracownicy`,
                module: 'administracja/polon',
                expectedPermissionCode: 'Polon.Konfiguracja.PlatformaAdministracyjna.Pracownicy.Lista',
                children: null,
              },
              {
                label: 'polonIds',
                text: $localize`Rodzaje dokumentów tożsamości`,
                module: 'administracja/polon',
                expectedPermissionCode: 'Polon.Konfiguracja.PlatformaAdministracyjna.RodzajeDokumentowTozsamosci.Lista',
                children: null,
              },
              {
                label: 'polonDidacticCycles',
                text: $localize`Cykle dydaktyczne`,
                module: 'administracja/polon',
                expectedPermissionCode: 'Polon.Konfiguracja.PlatformaAdministracyjna.CykleDydaktyczne.Lista',
                children: null,
              },
              {
                label: 'polonMaterialSupportTypes',
                text: $localize`Typy pomocy materialnej`,
                module: 'administracja/polon',
                expectedPermissionCode:
                  'Polon.Konfiguracja.PlatformaAdministracyjna.TypyPomocyMaterialnejStudentow.Lista',
                children: null,
              },
              {
                label: 'polonProfessionalTitles',
                text: $localize`Tytuły zawodowe`,
                module: 'administracja/polon',
                expectedPermissionCode: 'Polon.Konfiguracja.PlatformaAdministracyjna.TytulyZawodowe.Lista',
                children: null,
              },
            ],
          },
          {
            label: 'polonUstawienia',
            text: $localize`Ustawienia`,
            module: 'administracja/polon',
            expectedPermissionCode: 'Polon.PlatformaAdministracyjna.Ustawienia.Szczegoly',
            children: null,
          },
        ],
      },
      {
        label: 'administrationManageUsers',
        text: $localize`Zarządzanie użytkownikami`,
        module: 'administracja/zarzadzanie-uzytkownikami',
        expectedPermissionCode: 'UserAccess',
        children: [
          {
            label: 'administrationAzureAD',
            text: $localize`Azure`,
            module: 'administracja/zarzadzanie-uzytkownikami',
            expectedPermissionCode: 'UserAccess.Azure',
            children: [
              {
                label: 'administrationAzureADSettings',
                text: $localize`Ustawienia`,
                module: 'administracja/zarzadzanie-uzytkownikami/azure',
                expectedPermissionCode: 'UserAccess.Azure.Ustawienia.Podglad',
                children: null,
              },
              {
                label: 'administrationAzureADAudit',
                text: $localize`Audyt`,
                module: 'administracja/zarzadzanie-uzytkownikami/azure',
                expectedPermissionCode: 'UserAccess.Azure.Uzytkownicy.PrzegladanieListy',
                children: null,
              },
            ],
          },
          {
            label: 'administracjaKonfiguracjaUzytkownikow',
            text: $localize`Konfiguracja`,
            module: 'administracja/zarzadzanie-uzytkownikami',
            expectedPermissionCode: 'UserAccess.Ustawienia.PodgladAutomatyczneTworzenieKonta',
            children: null,
          },
          {
            label: 'administrationRoles',
            text: $localize`Role`,
            module: 'administracja/zarzadzanie-uzytkownikami',
            expectedPermissionCode: 'UserAccess.Role.PrzegladanieListy',
            children: null,
          },
          {
            label: 'administrationUsers',
            text: $localize`Użytkownicy`,
            module: 'administracja/zarzadzanie-uzytkownikami',
            expectedPermissionCode: 'UserAccess.Uzytkownicy.PrzegladanieListy',
            children: null,
          },
          {
            label: 'administrationUserGroups',
            text: $localize`Grupy użytkowników`,
            module: 'administracja/zarzadzanie-uzytkownikami',
            expectedPermissionCode: 'UserAccess.GrupyUzytkownikow.PrzegladanieListy',
            children: null,
          },
        ],
      },
      {
        label: 'administrationReporting',
        text: $localize`Raportowanie`,
        module: 'administracja',
        expectedPermissionCode: 'Raportowanie',
        children: [
          {
            label: 'administrationReports',
            text: $localize`Raporty`,
            module: 'administracja/raportowanie',
            expectedPermissionCode: 'Raportowanie.Raporty.Lista',
            children: null,
          },
          {
            label: 'administrationTemplates',
            text: $localize`Szablony`,
            module: 'administracja/raportowanie',
            expectedPermissionCode: 'Raportowanie.Szablony.Lista',
            children: null,
          },
          {
            label: 'administrationParameters',
            text: $localize`Parametry`,
            module: 'administracja/raportowanie',
            expectedPermissionCode: 'Raportowanie.Parametry.Lista',
            children: null,
          },
          {
            label: 'raportowanieOdmianaSlow',
            text: $localize`Słownik odmian`,
            module: 'administracja/raportowanie',
            expectedPermissionCode: 'Raportowanie.OdmianySlow.Lista',
            children: null,
          },
        ],
      },
      {
        label: 'administrationNumerators',
        text: $localize`Numeratory`,
        module: 'administracja',
        expectedPermissionCode: 'Systems.Numeratory.Lista',
        children: null,
      },
      {
        label: 'administrationPeople',
        text: $localize`Osoby`,
        module: 'administracja',
        expectedPermissionCode: 'KonfiguracjaUczelni.PlatformaAdministracyjna.Osoby.Lista',
        children: null,
      },
      {
        label: 'administrationEmployees',
        text: $localize`Pracownicy`,
        module: 'administracja',
        expectedPermissionCode: 'KonfiguracjaUczelni.PlatformaAdministracyjna.Pracownicy.Lista',
        children: null,
      },
    ],
  },
];

export const studiesMenu: IMenuElement[] = [
  {
    label: 'studies',
    text: $localize`Studia`,
    module: 'studia',
    isRootElement: true,
    expectedPermissionCode: 'Studia',
    children: [
      {
        label: 'studiesDictionaries',
        text: $localize`Słowniki`,
        module: 'studia/admin',
        expectedPermissionCode: 'Studia.PlatformaAdministracyjna.Slowniki',
        children: [
          {
            label: 'studiesScientificFields',
            text: $localize`Dziedziny nauk`,
            module: 'studia/admin',
            children: null,
            expectedPermissionCode:
              'Studia.PlatformaAdministracyjna.Slowniki.BudowanieProgramowStudiow.DziedzinyNauk.Lista',
          },
          {
            label: 'studiaFormaRealizacjiEgzaminuSesji',
            text: $localize`Formy realizacji egzaminu sesji`,
            module: 'studia/admin',
            children: null,
            expectedPermissionCode: 'Studia.PlatformaAdministracyjna.Slowniki.FormyRealizacjiEgzaminuSesji.Lista',
          },
          {
            label: 'studiesFormOfStudies',
            text: $localize`Formy studiów`,
            module: 'studia/admin',
            children: null,
            expectedPermissionCode:
              'Studia.PlatformaAdministracyjna.Slowniki.BudowanieProgramowStudiow.FormyStudiow.Lista',
          },
          {
            label: 'studiesAdminMobilityPlaces',
            text: $localize`Miejsca mobilności`,
            module: 'studia/admin',
            children: null,
            expectedPermissionCode: 'Studia.PlatformaAdministracyjna.Slowniki.Erasmus.MiejscaMobilnosci.Lista',
          },
          {
            label: 'studiesStudyingBasics',
            text: $localize`Podstawy studiowania`,
            module: 'studia/admin',
            children: null,
            expectedPermissionCode:
              'Studia.PlatformaAdministracyjna.Slowniki.ProgramyStudiowStudenta.PodstawyStudiowania.Lista',
          },
          {
            label: 'studiaPowodySkreslen',
            text: $localize`Powody skreśleń`,
            module: 'studia/admin',
            children: null,
            expectedPermissionCode:
              'Studia.PlatformaAdministracyjna.Slowniki.ProgramyStudiowStudenta.PowodDecyzjiOSkresleniu.Lista',
          },
          {
            label: 'studiaPowodySUrlopu',
            text: $localize`Powody urlopów`,
            module: 'studia/admin',
            children: null,
            expectedPermissionCode:
              'Studia.PlatformaAdministracyjna.Slowniki.ProgramyStudiowStudenta.PowodDecyzjiOUrlopie.Lista',
          },
          {
            label: 'studiesEducationLvl',
            text: $localize`Poziomy kształcenia`,
            module: 'studia/admin',
            children: null,
            expectedPermissionCode:
              'Studia.PlatformaAdministracyjna.Slowniki.BudowanieProgramowStudiow.PoziomyKsztalcenia.Lista',
          },
          {
            label: 'poziomyStudiow',
            text: $localize`Poziomy studiów`,
            module: 'studia/admin',
            children: null,
            expectedPermissionCode:
              'Studia.PlatformaAdministracyjna.Slowniki.BudowanieProgramowStudiow.PoziomyStudiow.Lista',
          },
          {
            label: 'studiesProfiles',
            text: $localize`Profile studiów`,
            module: 'studia/admin',
            children: null,
            expectedPermissionCode:
              'Studia.PlatformaAdministracyjna.Slowniki.BudowanieProgramowStudiow.ProfileStudiow.Lista',
          },
          {
            label: 'studiesBaseSubject',
            text: $localize`Przedmioty bazowe`,
            module: 'studia/admin',
            children: null,
            expectedPermissionCode: 'Studia.PlatformaAdministracyjna.Slowniki.PrzedmiotyBazowe.Lista',
          },
          {
            label: 'statusyRoboczeEtapow',
            text: $localize`Statusy robocze etapu`,
            module: 'studia/admin',
            children: null,
            expectedPermissionCode:
              'Studia.PlatformaAdministracyjna.Slowniki.EtapyProgramuStudiowStudenta.StatusyRobocze.Lista',
          },
          {
            label: 'studiesWorkingStatuses',
            text: $localize`Statusy robocze studenta`,
            module: 'studia/admin',
            children: null,
            expectedPermissionCode:
              'Studia.PlatformaAdministracyjna.Slowniki.ProgramyStudiowStudenta.StatusyRobocze.Lista',
          },
          {
            label: 'studiesTypesOfActivity',
            text: $localize`Typy aktywności`,
            module: 'studia/admin',
            children: null,
            expectedPermissionCode: 'Studia.PlatformaAdministracyjna.Slowniki.TypyAktywnosciDodatkowych.Lista',
          },
          {
            label: 'studiesGradeTypes',
            text: $localize`Typy ocen`,
            module: 'studia/admin',
            children: null,
            expectedPermissionCode: 'Studia.PlatformaAdministracyjna.Slowniki.ZaliczanieZajec.TypyOcen.Lista',
          },
          {
            label: 'studiesProtocolTypes',
            text: $localize`Typy protokołów`,
            module: 'studia/admin',
            children: null,
            expectedPermissionCode: 'Studia.PlatformaAdministracyjna.Slowniki.ZaliczanieZajec.TypyProtokolow.Lista',
          },
          {
            label: 'studiesPointsTypes',
            text: $localize`Typy punktów`,
            module: 'studia/admin',
            children: null,
            expectedPermissionCode:
              'Studia.PlatformaAdministracyjna.Slowniki.BudowanieProgramowStudiow.TypyPunktow.Lista',
          },
          {
            label: 'studiesClassType',
            text: $localize`Typy zajęć`,
            module: 'studia/admin',
            children: null,
            expectedPermissionCode: 'Studia.PlatformaAdministracyjna.Slowniki.PlanowanieZajec.TypyZajec.Lista',
          },
        ],
      },
      {
        label: 'studiesErasmus',
        text: $localize`Erasmus`,
        module: 'studia/admin',
        expectedPermissionCode: 'Studia.PlatformaAdministracyjna.Erasmus',
        children: [
          {
            label: 'studiesWorkersMobilities',
            text: $localize`Pracownicy`,
            module: 'studia/admin',
            expectedPermissionCode: 'Studia.PlatformaAdministracyjna.Erasmus.MobilnosciPracownikow.Lista',
            children: null,
          },
          {
            label: 'studiesStudentMobilities',
            text: $localize`Studenci`,
            module: 'studia/admin',
            expectedPermissionCode: 'Studia.PlatformaAdministracyjna.Erasmus.MobilnosciStudentow.Lista',
            children: null,
          },
        ],
      },
      {
        label: 'studiesConfiguration',
        text: $localize`Konfiguracja`,
        module: 'studia/admin',
        expectedPermissionCode: 'Studia.PlatformaAdministracyjna.Konfiguracja',
        children: [
          {
            label: 'studiaKonfiguracjaImmatrykulacja',
            text: $localize`Immatrykulacja`,
            module: 'studia/admin/konfiguracja',
            expectedPermissionCode: 'Rekrutacja.KonfiguracjeRekrutacji.Szczegoly',
            children: null,
          },
          {
            label: 'studiesConfigurationHistoryStudyPrograms',
            text: $localize`Historia programów studiów studenta`,
            module: 'studia/admin/konfiguracja',
            expectedPermissionCode:
              'Studia.PlatformaAdministracyjna.ProgramyStudiowStudenta.HistoriaZmian.Konfiguracja.Szczegoly',
            children: null,
          },
          {
            label: 'studiaKonfiguracjaDataZakonczeniaStudiow',
            text: $localize`Data zakończenia studiów`,
            module: 'studia/admin/konfiguracja',
            expectedPermissionCode:
              'Studia.PlatformaAdministracyjna.ProgramyStudiowStudenta.AkcjeMasowe.UstawDatyZakonczenia',
            children: null,
          },
          {
            label: 'studiaKonfiguracjaSygnatury',
            text: $localize`Sygnatury`,
            module: 'studia/admin/konfiguracja',
            expectedPermissionCode: 'Studia.PlatformaAdministracyjna.Konfiguracja.KonfiguracjeSygnatur.Lista',
            children: null,
          },
          {
            label: 'studiesConfigurationAverageGrades',
            text: $localize`Średnie ocen`,
            module: 'studia/admin/konfiguracja',
            expectedPermissionCode: 'Studia.PlatformaAdministracyjna.KonfiguracjeSrednichOcen',
            children: null,
          },
          {
            label: 'studiesConfigurationAlbumsNumbers',
            text: $localize`Numery albumów`,
            module: 'studia/admin/konfiguracja',
            expectedPermissionCode: 'Studia.PlatformaAdministracyjna.NumeratoryNumeruAlbumu.Lista',
            children: null,
          },
          {
            label: 'studiesConfigurationEvaluationProtocols',
            text: $localize`Protokoły ocen`,
            module: 'studia/admin/konfiguracja',
            expectedPermissionCode: 'Studia.PlatformaAdministracyjna.NumeratoryProtokoluOcen.Lista',
            children: null,
          },
          {
            label: 'studiaKonfiguracjaTeczka',
            text: $localize`Teczka`,
            module: 'studia/admin/konfiguracja',
            expectedPermissionCode: 'Studia.PlatformaAdministracyjna.Konfiguracja.KonfiguracjaTeczki.Katalogi.Lista',
            children: null,
          },
          {
            label: 'studiaKonfiguracjaKonfiguracjaSlubowania',
            text: $localize`Konfiguracja ślubowania`,
            module: 'studia/admin/konfiguracja',
            expectedPermissionCode: 'Studia.PlatformaAdministracyjna.Konfiguracja.KonfiguracjeSlubowania.Podglad',
            children: null,
          },
        ],
      },
      {
        label: 'studiesLearningEffect',
        text: $localize`Efekty uczenia`,
        module: 'studia/admin',
        expectedPermissionCode: 'Studia.PlatformaAdministracyjna.EfektyUczeniaSie',
        children: [
          {
            label: 'studiesEducationStandards',
            text: $localize`Standardy kształcenia`,
            module: 'studia/admin/efekty-uczenia',
            children: null,
            expectedPermissionCode: 'Studia.PlatformaAdministracyjna.EfektyUczeniaSie.StandardyKsztalcenia.Typy.Lista',
          },
          {
            label: 'studiesDirectionalEffects',
            text: $localize`Efekty kierunkowe`,
            module: 'studia/admin/efekty-uczenia',
            children: null,
            expectedPermissionCode: 'Studia.PlatformaAdministracyjna.EfektyUczeniaSie.EfektyKierunkowe.Lista',
          },
          {
            label: 'studiesPolishQualificationFramework',
            text: $localize`Polska Rama Kwalifikacji`,
            module: 'studia/admin/efekty-uczenia',
            expectedPermissionCode: 'Studia.PlatformaAdministracyjna.EfektyUczeniaSie.PolskieRamyKwalifikacji',
            children: [
              {
                label: 'studiesPolishQualificationFrameworkCategories',
                text: $localize`Kategorie`,
                module: 'studia/admin/efekty-uczenia/polskie-ramy-kwalifikacji',
                children: null,
                expectedPermissionCode:
                  'Studia.PlatformaAdministracyjna.EfektyUczeniaSie.PolskieRamyKwalifikacji.Slowniki.KategorieCharakterystyki.Lista',
              },
              {
                label: 'studiesPolishQualificationFrameworkLevel',
                text: $localize`Poziomy`,
                module: 'studia/admin/efekty-uczenia/polskie-ramy-kwalifikacji',
                children: null,
                expectedPermissionCode:
                  'Studia.PlatformaAdministracyjna.EfektyUczeniaSie.PolskieRamyKwalifikacji.Slowniki.Poziomy.Lista',
              },
              {
                label: 'studiesPolishQualificationFrameworkPoints',
                text: $localize`Punkty`,
                module: 'studia/admin/efekty-uczenia/polskie-ramy-kwalifikacji',
                children: null,
                expectedPermissionCode:
                  'Studia.PlatformaAdministracyjna.EfektyUczeniaSie.PolskieRamyKwalifikacji.Punkty.Lista',
              },
            ],
          },
        ],
      },
      {
        label: 'studiaEgzaminySesji',
        text: $localize`Egzaminy sesji`,
        module: 'studia/admin',
        expectedPermissionCode: 'Studia.PlatformaAdministracyjna.EgzaminySesji.Lista',
        children: null,
      },
      {
        label: 'studiesUniversityCalendar',
        text: $localize`Kalendarz uczelniany`,
        module: 'studia/admin',
        expectedPermissionCode: 'Studia.PlatformaAdministracyjna.KalendarzUczelniany.DniWolne.Lista',
        children: [
          {
            label: 'studiesDaysOff',
            text: $localize`Dni wolne`,
            module: 'studia/admin',
            expectedPermissionCode: 'Studia.PlatformaAdministracyjna.KalendarzUczelniany.DniWolne.Lista',
            children: null,
          },
        ],
      },
      {
        label: '',
        text: $localize`Karty przedmiotów`,
        module: 'studia/admin',
        expectedPermissionCode: 'Studia.PlatformaAdministracyjna.KartyPrzedmiotow',
        children: [
          {
            label: 'studiesItemCardsConfiguration',
            text: $localize`Konfiguracja`,
            module: 'studia/admin',
            expectedPermissionCode: 'Studia.PlatformaAdministracyjna.KartyPrzedmiotow.Konfiguracje',
            children: [
              {
                label: 'studiesItemCardsConfigurationWorkLoad',
                text: $localize`Obciążenia pracą`,
                module: 'studia/admin/karty-przedmiotow/konfiguracja',
                children: null,
                expectedPermissionCode:
                  'Studia.PlatformaAdministracyjna.KartyPrzedmiotow.Konfiguracje.WpisyObciazeniaPraca.Lista',
              },
            ],
          },
          {
            label: 'studiesItemCards',
            text: $localize`Lista kart przedmiotów`,
            module: 'studia/admin',
            children: null,
            expectedPermissionCode: 'Studia.PlatformaAdministracyjna.KartyPrzedmiotow.Lista',
          },
        ],
      },
      {
        label: 'studiesPensum',
        text: $localize`Pensum`,
        module: 'studia/wykladowca',
        expectedPermissionCode: 'Studia.PlatformaPracownikaNaukowego.Pensum.Lista',
        children: null,
      },
      {
        label: 'studiesLecturerProtocols',
        text: $localize`Protokoły ocen`,
        module: 'studia/wykladowca',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaPracownikaNaukowego.Protokoly.Lista',
      },
      {
        label: 'studiaWykladowcaEgzaminySesji',
        text: $localize`Moje egzaminy sesji`,
        module: 'studia/wykladowca',
        expectedPermissionCode: 'Studia.PlatformaPracownikaNaukowego.EgzaminySesji.Lista',
        children: null,
      },
      {
        label: 'studiesLecturerErasmus',
        text: $localize`Erasmus`,
        module: 'studia/wykladowca',
        expectedPermissionCode: 'Studia.PlatformaPracownikaNaukowego.Erasmus',
        children: [
          {
            label: 'studiesLecturerErasmusDecisions',
            text: $localize`Decyzje`,
            module: 'studia/wykladowca',
            expectedPermissionCode: 'Studia.PlatformaPracownikaNaukowego.Erasmus.Decyzje.Lista',
            children: null,
          },
          {
            label: 'studiesLecturerErasmusMobilityPlaces',
            text: $localize`Miejsca mobilności`,
            module: 'studia/wykladowca',
            children: null,
            expectedPermissionCode: 'Studia.PlatformaPracownikaNaukowego.Erasmus.MiejscaMobilnosci.Lista',
          },
          {
            label: 'studiesLecturerErasmusWorkersMobilities',
            text: $localize`Pracownicy`,
            module: 'studia/wykladowca',
            expectedPermissionCode: 'Studia.PlatformaPracownikaNaukowego.Erasmus.MobilnosciPracownikow.Lista',
            children: null,
          },
          {
            label: 'studiesLecturerErasmusStudentsMobilities',
            text: $localize`Studenci`,
            module: 'studia/wykladowca',
            expectedPermissionCode: 'Studia.PlatformaPracownikaNaukowego.Erasmus.MobilnosciStudentow.Lista',
            children: null,
          },
        ],
      },
      {
        label: 'studiesHospitalizationProtocols',
        text: $localize`Protokoły hospitacji`,
        module: 'studia/wykladowca',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaPracownikaNaukowego.ProtokolyHospitacji.Lista',
      },
      {
        label: 'studiesLecturerStudyGroups',
        text: $localize`Moje grupy zajęciowe`,
        module: 'studia/wykladowca',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaPracownikaNaukowego.GrupyZajecioweProwadzacego.Lista',
      },
      {
        label: 'studiesDeanGroups',
        text: $localize`Grupy dziekańskie`,
        module: 'studia/admin',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaAdministracyjna.PlanowanieZajec.GrupyDziekanskie.PrzegladStudentow',
      },
      {
        label: 'studiesFieldOfStudy',
        text: $localize`Kierunki studiów`,
        module: 'studia/admin',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaAdministracyjna.BudowanieProgramowStudiow.KierunkiStudiow.Lista',
      },
      {
        label: 'studiesStudyPrograms',
        text: $localize`Programy studiów`,
        module: 'studia/admin',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaAdministracyjna.BudowanieProgramowStudiow.ProgramyStudiow.Lista',
      },
      {
        label: 'studiesSubjectsInTheCycle',
        text: $localize`Przedmioty w cyklu`,
        module: 'studia/admin',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaAdministracyjna.PlanowanieZajec.PrzedmiotyWCyklu.Lista',
      },
      {
        label: 'studiesReports',
        text: $localize`Raporty`,
        module: 'studia/admin',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaAdministracyjna.Raporty.Lista',
      },
      {
        label: 'studiesStudents',
        text: $localize`Studenci`,
        module: 'studia/admin',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaAdministracyjna.Studenci.Lista',
      },
      {
        label: 'studiesLecturers',
        text: $localize`Wykładowcy`,
        module: 'studia/admin',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaAdministracyjna.Wykladowcy.Lista',
      },
      {
        label: 'studiesHospitalizationProtocols',
        text: $localize`Protokoły hospitacji`,
        module: 'studia/admin',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaAdministracyjna.ProtokolyHospitacji.Lista',
      },
      {
        label: 'studiaProtokolyOcen',
        text: $localize`Protokoły ocen`,
        module: 'studia/admin',
        expectedPermissionCode: 'Studia.PlatformaAdministracyjna.ZaliczanieZajec.Protokoly.Lista',
        children: null,
      },
      {
        label: 'studiesPensum',
        text: $localize`Pensum`,
        module: 'studia/admin',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaAdministracyjna.Wykladowcy.Pensum.Lista',
      },
      {
        label: 'studiesSubjectsCards',
        text: $localize`Karty przedmiotów`,
        module: 'studia/student',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaStudenta.KartyPrzedmiotow.Lista',
      },
      {
        label: 'studiesStudentBuildingMaps',
        text: $localize`Mapy budynków`,
        module: 'studia/student',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaStudenta.MapyBudynkow.PodgladListyBudynkow',
      },
      {
        label: 'studiesAdditionalActivities',
        text: $localize`Aktywności dodatkowe`,
        module: 'studia/student',
        expectedPermissionCode: 'Studia.PlatformaStudenta.AktywnosciDodatkowe.PodgladListy',
        children: [
          {
            label: 'studiesAdditionalActivitiesAll',
            text: $localize`Wszystkie`,
            module: 'studia/student/aktywnosci-dodatkowe',
            children: null,
            expectedPermissionCode: 'Studia.PlatformaStudenta.AktywnosciDodatkowe.PodgladListy',
          },
          {
            label: 'studiesAdditionalActivitiesSave',
            text: $localize`Zapisane`,
            module: 'studia/student/aktywnosci-dodatkowe',
            children: null,
            expectedPermissionCode: 'Studia.PlatformaStudenta.AktywnosciDodatkoweStudenta.PodgladListy',
          },
        ],
      },
      {
        label: 'studiesAdditionalActivities',
        text: $localize`Aktywności dodatkowe`,
        module: 'studia/admin',
        expectedPermissionCode: 'Studia.PlatformaAdministracyjna.Slowniki.AktywnosciDodatkowe.Lista',
        children: null,
      },
      {
        label: 'studiesStudentGrades',
        text: $localize`Moje oceny`,
        module: 'studia/student',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaStudenta.Przedmioty.Podglad',
      },
      {
        label: 'studiaStudentEgzaminySesji',
        text: $localize`Moje egzaminy sesji`,
        module: 'studia/student',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaStudenta.EgzaminySesji.Lista',
      },
      {
        label: 'studiesStudentSubjectToStageAssignment',
        text: $localize`Podpięcia przedmiotów pod etap`,
        module: 'studia/student',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaStudenta.PodpieciaPrzedmiotuPodEtap.PodgladListy',
      },
      {
        label: 'studiesStudentCycleSubjects',
        text: $localize`Przedmioty w cyklach`,
        module: 'studia/student',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaStudenta.PrzedmiotyWCyklu.PodgladListy',
      },
      {
        label: 'studiesStudentDeanGroups',
        text: $localize`Moje grupy dziekańskie`,
        module: 'studia/student',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaStudenta.GrupyDziekanskie.PodgladListy',
      },
      {
        label: 'studiesStudentStudyGroups',
        text: $localize`Moje grupy zajęciowe`,
        module: 'studia/student',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaStudenta.GrupyZajeciowe.PodgladListy',
      },
      {
        label: 'studiesStudentMyStudyPrograms',
        text: $localize`Moje programy studiów`,
        module: 'studia/student',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaStudenta.ProgramyStudiowStudenta.PodgladListy',
      },
      {
        label: 'studiesAdminCoursesCalendar',
        text: $localize`Terminy zajęć`,
        module: 'studia/admin',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaAdministracyjna.PlanowanieZajec.TerminyZajec.Lista',
      },
      {
        label: 'studiesStudentStudyProgram',
        text: $localize`Programy studiów`,
        module: 'studia/student',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaStudenta.ProgramyStudiow.Lista',
      },
      {
        label: 'studiesStudentCoursesCalendar',
        text: $localize`Terminy zajęć`,
        module: 'studia/student',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaStudenta.TerminyZajec.Lista',
      },
      {
        label: 'studiesStudentOwnCoursesCalendar',
        text: $localize`Moje terminy zajęć`,
        module: 'studia/student',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaStudenta.TerminyZajecStudenta.Podglad',
      },
      {
        label: 'studiesLecturerOwnCoursesCalendar',
        text: $localize`Moje terminy zajęć`,
        module: 'studia/wykladowca',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaPracownikaNaukowego.TerminyZajecPracownikaNaukowego.Podglad',
      },
      {
        label: 'studiesLecturerStudyPrograms',
        text: $localize`Programy studiów`,
        module: 'studia/wykladowca',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaPracownikaNaukowego.ProgramyStudiow.Lista',
      },
      {
        label: 'studiesItemCards',
        text: $localize`Karty przedmiotów`,
        module: 'studia/wykladowca',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaPracownikaNaukowego.KartyPrzedmiotow.Lista',
      },
      {
        label: 'recruitment',
        text: $localize`Immatrykulacja`,
        module: 'studia/admin',
        children: null,
        expectedPermissionCode: 'Rekrutacja',
      },
      {
        label: 'studiaLegitymacje',
        text: $localize`Legitymacje`,
        module: 'studia/admin',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaAdministracyjna.Legitymacje.ListaStudentow',
      },
      {
        label: 'certificateRegister',
        text: $localize`Rejestr zaświadczeń`,
        module: 'studia/admin',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaAdministracyjna.Zaswiadczenia.Lista',
      },
      {
        label: 'studiesStudentLecturers',
        text: $localize`Wykładowcy`,
        module: 'studia/student',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaStudenta.Wykladowcy.Lista',
      },
      {
        label: 'studiaPracownikNaukowyKonsultacje',
        text: $localize`Konsultacje`,
        module: 'studia/wykladowca',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaPracownikaNaukowego.TerminyKonsultacji.Lista',
      },
      {
        label: 'studiesLecturerLecturers',
        text: $localize`Wykładowcy`,
        module: 'studia/wykladowca',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaPracownikaNaukowego.Wykladowcy.Lista',
      },
    ],
  },
];

export const dyplomowanieMenu: IMenuElement[] = [
  {
    label: 'dyplomowanie',
    text: $localize`Dyplomowanie`,
    module: 'dyplomowanie',
    expectedPermissionCode: 'Dyplomowanie',
    isRootElement: true,
    children: [
      {
        label: 'dyplomowanieEgzaminy',
        text: $localize`Egzaminy dyplomowe`,
        module: 'dyplomowanie/admin',
        expectedPermissionCode: 'Dyplomowanie.PracownikAdministracyjny.EgzaminyDyplomowe.PrzegladanieListy',
        children: null,
      },
      {
        label: 'dyplomowaniePraceDyplomowe',
        text: $localize`Prace dyplomowe`,
        module: 'dyplomowanie/admin',
        expectedPermissionCode: 'Dyplomowanie.PracownikAdministracyjny.PraceDyplomowe.PrzegladanieListy',
        children: null,
      },
      {
        label: 'dyplomowanieRaporty',
        text: $localize`Raporty`,
        module: 'dyplomowanie/admin',
        expectedPermissionCode: 'Dyplomowanie.PlatformaAdministracyjna.Raporty',
        children: null,
      },
      {
        label: 'dyplomowanieKonfiguracja',
        text: $localize`Konfiguracja`,
        module: 'dyplomowanie',
        expectedPermissionCode: 'Dyplomowanie.PracownikAdministracyjny.Slowniki',
        children: [
          {
            label: 'dyplomowanieAlgorytmyObliczaniaOceny',
            text: $localize`Algorytmy obliczania oceny`,
            module: 'dyplomowanie/admin',
            expectedPermissionCode:
              'Dyplomowanie.PracownikAdministracyjny.Slowniki.Oceny.AlgorytmyObliczaniaOceny.PrzegladanieListy',
            children: null,
          },
          {
            label: 'dyplomowanieDozwoloneTypyPlikow',
            text: $localize`Dopuszczalne rozszerzenia plików`,
            module: 'dyplomowanie/admin',
            expectedPermissionCode:
              'Dyplomowanie.PracownikAdministracyjny.Slowniki.DopuszczalneInneRozszerzeniaPliku.PrzegladanieListy',
            children: null,
          },
          {
            label: 'dyplomowanieDozwoloneTypyProtokolowRecenzji',
            text: $localize`Dozwolone typy protokołów recenzji`,
            module: 'dyplomowanie/admin',
            expectedPermissionCode:
              'Dyplomowanie.PracownikAdministracyjny.Slowniki.DozwoloneTypyProtokolu.PrzegladanieListy',
            children: null,
          },
          {
            label: 'dyplomowanieKonfiguracjeProcesuDyplomowania',
            text: $localize`Konfiguracje procesu dyplomowania`,
            expectedPermissionCode: 'Dyplomowanie.PracownikAdministracyjny.Konfiguracje.Lista',
            module: 'dyplomowanie/admin',
            children: null,
          },
          {
            label: 'dyplomowanieMapowaniaPoziomKsztalceniaTypPracy',
            text: $localize`Mapowania poziomów kształcenia – typ pracy`,
            module: 'dyplomowanie/admin',
            expectedPermissionCode:
              'Dyplomowanie.PracownikAdministracyjny.Slowniki.TypyPracyDyplomowej.PrzegladanieListy',
            children: null,
          },
          {
            label: 'dyplomowanieKonfiguracjaOznaczaniaPrac',
            text: $localize`Oznaczanie prac`,
            module: 'dyplomowanie/admin',
            expectedPermissionCode:
              'Dyplomowanie.PracownikAdministracyjny.Slowniki.KonfiguracjeOznaczaniaPrac.PrzegladanieListy',
            children: null,
          },
        ],
      },
      {
        label: 'dyplomowanieSlowniki',
        text: $localize`Słowniki`,
        module: 'dyplomowanie',
        expectedPermissionCode: 'Dyplomowanie.PracownikAdministracyjny.Slowniki',
        children: [
          {
            label: 'dyplomowanieJezyki',
            text: $localize`Języki`,
            module: 'dyplomowanie/admin',
            expectedPermissionCode: 'Dyplomowanie.PracownikAdministracyjny.Slowniki.Jezyki.PrzegladanieListy',
            children: null,
          },
          {
            label: 'dyplomowaniePytaniaEgzaminacyjne',
            text: $localize`Pytania egzaminacyjne`,
            module: 'dyplomowanie/admin',
            expectedPermissionCode:
              'Dyplomowanie.PracownikAdministracyjny.Slowniki.PytaniaEgzaminacyjne.PrzegladanieListy',
            children: null,
          },
          {
            label: 'dyplomowanieTypyOcen',
            text: $localize`Typy ocen`,
            module: 'dyplomowanie/admin',
            expectedPermissionCode: 'Dyplomowanie.PracownikAdministracyjny.Slowniki.Oceny.TypyOcen.PrzegladanieListy',
            children: null,
          },
          {
            label: 'dyplomowanieTypyPracDyplomowych',
            text: $localize`Typy prac dyplomowych`,
            module: 'dyplomowanie/admin',
            expectedPermissionCode:
              'Dyplomowanie.PracownikAdministracyjny.Slowniki.TypyPracyDyplomowej.PrzegladanieListy',
            children: null,
          },
          {
            label: 'dyplomowanieTypyProtokolowRecenzji',
            text: $localize`Typy protokołów recenzji`,
            module: 'dyplomowanie/admin',
            expectedPermissionCode: 'Dyplomowanie.PracownikAdministracyjny.Slowniki.TypyProtokolu.PrzegladanieListy',
            children: null,
          },
        ],
      },
      {
        label: 'dyplomowanieJsa',
        text: $localize`Integracja z JSA`,
        module: 'dyplomowanie/admin',
        expectedPermissionCode: 'Dyplomowanie.PracownikAdministracyjny.Jsa',
        children: [
          {
            label: 'dyplomowanieJsaEksporty',
            text: $localize`Eksporty`,
            module: 'dyplomowanie/admin',
            expectedPermissionCode: 'Dyplomowanie.PracownikAdministracyjny.Jsa.Proby.DziennikZdarzen',
            children: null,
          },
          {
            label: 'dyplomowanieJsaJezykiRaportow',
            text: $localize`Języki raportów`,
            module: 'dyplomowanie/admin',
            expectedPermissionCode: 'Dyplomowanie.PracownikAdministracyjny.Jsa.JezykiRaportuJsa.PrzegladanieListy',
            children: null,
          },
          {
            label: 'dyplomowanieJsaKonfiguracja',
            text: $localize`Konfiguracja`,
            module: 'dyplomowanie/admin',
            expectedPermissionCode: 'Dyplomowanie.PracownikAdministracyjny.Jsa.Konfiguracje.PrzegladanieListy',
            children: null,
          },
          {
            label: 'dyplomowanieJsaTypyPracDyplomowych',
            text: $localize`Typy prac dyplomowych`,
            module: 'dyplomowanie/admin',
            expectedPermissionCode:
              'Dyplomowanie.PracownikAdministracyjny.Jsa.TypyPracyDyplomowejJsa.PrzegladanieListy',
            children: null,
          },
          {
            label: 'dyplomowanieJsaMapowaniaTypowPracDyplomowych',
            text: $localize`Mapowania typów prac dyplomowych`,
            module: 'dyplomowanie/admin',
            expectedPermissionCode:
              'Dyplomowanie.PracownikAdministracyjny.Jsa.TypyPracyDyplomowejJsaTypPracyDyplomowej.PrzegladanieListy',
            children: null,
          },
          {
            label: 'dyplomowanieJsaMapowaniaTytulowNaukowych',
            text: $localize`Mapowania tytułów naukowych`,
            module: 'dyplomowanie/admin',
            expectedPermissionCode: 'Dyplomowanie.PracownikAdministracyjny.Jsa.Konfiguracje.TytulyNaukowe.Lista',
            children: null,
          },
          {
            label: 'dyplomowanieJsaTypyRaportow',
            text: $localize`Typy raportów`,
            module: 'dyplomowanie/admin',
            expectedPermissionCode: 'Dyplomowanie.PracownikAdministracyjny.Jsa.TypyRaportuJsa.PrzegladanieListy',
            children: null,
          },
        ],
      },
      {
        label: 'dyplomowanieOrppd',
        text: $localize`Integracja z ORPPD`,
        module: 'dyplomowanie/admin',
        expectedPermissionCode: 'Dyplomowanie.PracownikAdministracyjny.Orppd',
        children: [
          {
            label: 'dyplomowanieOrppdEksporty',
            text: $localize`Eksporty`,
            module: 'dyplomowanie/admin',
            expectedPermissionCode: 'Dyplomowanie.PracownikAdministracyjny.Orppd.EksportyDoOrppd.PrzegladanieListy',
            children: null,
          },
          {
            label: 'dyplomowanieOrppdKonfiguracja',
            text: $localize`Konfiguracja`,
            module: 'dyplomowanie/admin',
            expectedPermissionCode: 'Dyplomowanie.PracownikAdministracyjny.Orppd.OrppdJednostka.Podglad',
            children: null,
          },
          {
            label: 'dyplomowanieOrppdKonfiguracjaJednostek',
            text: $localize`Konfiguracja integracji jednostek org.`,
            expectedPermissionCode: 'Dyplomowanie.PracownikAdministracyjny.Orppd.OrppdJednostka.Podglad',
            module: 'dyplomowanie/admin',
            children: null,
          },
          {
            label: 'dyplomowanieOrppdKraje',
            text: $localize`Mapowania krajów`,
            expectedPermissionCode:
              'Dyplomowanie.PracownikAdministracyjny.Orppd.MapowaniaKrajuNaKrajOrppd.PrzegladanieListy',
            module: 'dyplomowanie/admin',
            children: null,
          },
          {
            label: 'dyplomowanieOrppdRodzajeDokumentowTozsamosci',
            text: $localize`Mapowania rodzajów dokumentów tożsamości`,
            expectedPermissionCode:
              'Dyplomowanie.PracownikAdministracyjny.Orppd.RodzajeDokumentowTozsamosciRodzajeDokumentowTozsamosciOrppd.PrzegladanieListy',
            module: 'dyplomowanie/admin',
            children: null,
          },
          {
            label: 'dyplomowanieOrppdMapowaniaTypPracyDyplomowejTytulNaukowy',
            text: $localize`Mapowania tytułów naukowych`,
            expectedPermissionCode:
              'Dyplomowanie.PracownikAdministracyjny.Orppd.TypyPracyDyplomowejTytulyNaukoweOrppd.PrzegladanieListy',
            module: 'dyplomowanie/admin',
            children: null,
          },
        ],
      },
      {
        label: 'dyplomowanieEgzaminyLecturer',
        text: $localize`Egzaminy dyplomowe`,
        module: 'dyplomowanie/wykladowca',
        expectedPermissionCode: 'Dyplomowanie.PracownikNaukowy.EgzaminyDyplomowe.PodgladListy',
        children: null,
      },
      {
        label: 'dyplomowaniePraceDyplomoweLecturer',
        text: $localize`Prace dyplomowe`,
        module: 'dyplomowanie/wykladowca',
        expectedPermissionCode: 'Dyplomowanie.PracownikNaukowy.PraceDyplomowe.PrzeglądanieListyPrac',
        children: null,
      },
      {
        label: 'dyplomowanieTasks',
        text: $localize`Moje zadania`,
        module: 'dyplomowanie/wykladowca',
        expectedPermissionCode: 'Dyplomowanie.PracownikNaukowy.Zadania',
        children: null,
      },
      {
        label: 'dyplomowanieMyExams',
        text: $localize`Moje egzaminy dyplomowe`,
        module: 'dyplomowanie/student',
        expectedPermissionCode: 'Dyplomowanie.Student.EgzaminyDyplomowe.PodgladListy',
        children: null,
      },
      {
        label: 'dyplomowanieMyThesis',
        text: $localize`Moje prace dyplomowe`,
        module: 'dyplomowanie/student',
        expectedPermissionCode: 'Dyplomowanie.Student.PraceDyplomowe.PrzeglądanieListyPrac',
        children: null,
      },
    ],
  },
];

export const practicesMenu: IMenuElement[] = [
  {
    label: 'practices',
    text: $localize`Praktyki`,
    module: 'praktyki',
    expectedPermissionCode: 'Praktyki',
    isRootElement: true,
    children: [
      {
        label: 'practiceDictionaries',
        text: $localize`Słowniki`,
        module: 'praktyki/administrator',
        expectedPermissionCode: 'Praktyki.PracownikAdministracyjny.Slowniki',
        children: [
          {
            label: 'practicePlaces',
            text: $localize`Miejsca praktyk`,
            module: 'praktyki/administrator',
            children: null,
            expectedPermissionCode: 'Praktyki.PracownikAdministracyjny.Slowniki.MiejscaPraktyk.Lista',
          },
          {
            label: 'practiceTypesContracts',
            text: $localize`Rodzaje umów`,
            module: 'praktyki/administrator',
            children: null,
            expectedPermissionCode: 'Praktyki.PracownikAdministracyjny.Slowniki.RodzajeUmowy.Lista',
          },
          {
            label: 'practiceAttachmentsExtensions',
            text: $localize`Rozszerzenia załączników`,
            module: 'praktyki/administrator',
            children: null,
            expectedPermissionCode: 'Praktyki.PracownikAdministracyjny.Slowniki.RozszerzenieZalacznikow.Lista',
          },
          {
            label: 'practiceTypes',
            text: $localize`Typy praktyk`,
            module: 'praktyki/administrator',
            children: null,
            expectedPermissionCode: 'Praktyki.PracownikAdministracyjny.Slowniki.TypyPraktyk.Lista',
          },
          {
            label: 'practiceAttachmentsTypes',
            text: $localize`Typy załączników`,
            module: 'praktyki/administrator',
            children: null,
            expectedPermissionCode: 'Praktyki.PracownikAdministracyjny.Slowniki.TypyZalacznikow.Lista',
          },
        ],
      },
      {
        label: 'practiceOffersLecturer',
        text: $localize`Oferty praktyk`,
        module: 'praktyki/wykladowca',
        children: null,
        expectedPermissionCode: 'Praktyki.PracownikNaukowy.OfertyPraktyk.Lista',
      },
      {
        label: 'praktykiStudentowLecturer',
        text: $localize`Praktyki studentów`,
        module: 'praktyki/wykladowca',
        children: null,
        expectedPermissionCode: 'Praktyki.PracownikNaukowy.PraktykiStudentow.Lista',
      },
      {
        label: 'praktykiStudentowStudent',
        text: $localize`Moje praktyki`,
        module: 'praktyki/student',
        children: null,
        expectedPermissionCode: 'Praktyki.Student.PraktykiStudentow.Lista',
      },
      {
        label: 'practiceOffersStudent',
        text: $localize`Oferty praktyk`,
        module: 'praktyki/student',
        children: null,
        expectedPermissionCode: 'Praktyki.Student.OfertyPraktyk.Lista',
      },
      {
        label: 'practiceOffers',
        text: $localize`Oferty praktyk`,
        module: 'praktyki/administrator',
        children: null,
        expectedPermissionCode: 'Praktyki.PracownikAdministracyjny.OfertyPraktyk.Lista',
      },
      {
        label: 'praktykiStudentow',
        text: $localize`Praktyki studentów`,
        module: 'praktyki/administrator',
        children: null,
        expectedPermissionCode: 'Praktyki.PracownikAdministracyjny.PraktykiStudentow.Lista',
      },
      {
        label: 'practiceInternshipGuards',
        text: $localize`Opiekunowie praktyk`,
        module: 'praktyki/administrator',
        children: null,
        expectedPermissionCode: 'Praktyki.PracownikAdministracyjny.OpiekunowiePraktyk.Lista',
      },
    ],
  },
];

export const requestsMenu: IMenuElement[] = [
  {
    label: 'requests',
    text: $localize`Wnioski`,
    module: 'wnioski',
    isRootElement: true,
    expectedPermissionCode: 'Wnioski',
    children: [
      {
        label: 'requestsDictionaries',
        text: $localize`Słowniki`,
        module: 'wnioski/admin',
        expectedPermissionCode: 'Wnioski.PlatformaAdministracyjna.Slowniki',
        children: [
          {
            label: 'requestsLegalJustifications',
            text: $localize`Uzasadnienia prawne`,
            module: 'wnioski/admin',
            expectedPermissionCode: 'Wnioski.PlatformaAdministracyjna.Slowniki.UzasadnieniaPrawne',
            children: [
              {
                label: 'requestsLegalJustificationsOfSubjectsDecision',
                text: $localize`Decyzje przedmiotowe`,
                module: 'wnioski/admin',
                expectedPermissionCode:
                  'Wnioski.PlatformaAdministracyjna.Slowniki.UzasadnieniaPrawne.DecyzjiPrzedmiotowej.Lista',
                children: null,
              },
              {
                label: 'requestsLegalJustificationsOfInitRefusal',
                text: $localize`Odmowy wszczęcia`,
                module: 'wnioski/admin',
                expectedPermissionCode:
                  'Wnioski.PlatformaAdministracyjna.Slowniki.UzasadnieniaPrawne.OdmowyWszczecia.Lista',
                children: null,
              },
              {
                label: 'requestsLegalJustificationsOfProceedingsRemission',
                text: $localize`Umorzenia postępowania`,
                module: 'wnioski/admin',
                expectedPermissionCode:
                  'Wnioski.PlatformaAdministracyjna.Slowniki.UzasadnieniaPrawne.UmorzeniaPostepowania.Lista',
                children: null,
              },
            ],
          },
          {
            label: 'requestsDecisionMakers',
            text: $localize`Osoby decyzyjne`,
            module: 'wnioski/admin',
            expectedPermissionCode: 'Wnioski.PlatformaAdministracyjna.Slowniki.OsobyDecyzyjne.Lista',
            children: null,
          },
          {
            label: 'requestsCaseTypes',
            text: $localize`Rodzaje spraw`,
            module: 'wnioski/admin',
            expectedPermissionCode: 'Wnioski.PlatformaAdministracyjna.Slowniki.RodzajeSpraw.PrzegladanieListy',
            children: null,
          },
          {
            label: 'requestsKindsOf',
            text: $localize`Rodzaje podań`,
            module: 'wnioski/admin',
            expectedPermissionCode: 'Wnioski.PlatformaAdministracyjna.Slowniki.RodzajePodan.PrzegladanieListy',
            children: null,
          },
          {
            label: 'requestsBenefitTypes',
            text: $localize`Typy dodatkowych świadczeń`,
            module: 'wnioski/admin',
            expectedPermissionCode:
              'Wnioski.PlatformaAdministracyjna.DodatkoweSwiadczenia.TypDodatkowegoSwiadczenia.Lista',
            children: null,
          },
          {
            label: 'requestsSettlementsTypes',
            text: $localize`Typy rozstrzygnięć`,
            module: 'wnioski/admin',
            expectedPermissionCode: 'Wnioski.PlatformaAdministracyjna.Slowniki.TypyRozstrzygniec.Lista',
            children: null,
          },
          {
            label: 'requestsStudentsCasesStatusVisibility',
            text: $localize`Widoczność statusów sprawy u studenta`,
            module: 'wnioski/admin',
            expectedPermissionCode: 'Wnioski.PlatformaAdministracyjna.StatusySprawyWidocznoscDlaStudenta.Lista',
            children: null,
          },
        ],
      },
      {
        label: 'requestsStudentRequests',
        text: $localize`Podania studentów`,
        module: 'wnioski/admin',
        expectedPermissionCode: 'Wnioski.PlatformaAdministracyjna.PodaniaStudenta.PrzegladanieListy',
        children: null,
      },
      {
        label: 'requestsStudentsCases',
        text: $localize`Sprawy studentów`,
        module: 'wnioski/admin',
        expectedPermissionCode: 'Wnioski.PlatformaAdministracyjna.SprawyStudenta.PrzegladanieListy',
        children: null,
      },
      {
        label: 'requestsDashboard',
        text: $localize`Wykaz moich spraw`,
        module: 'wnioski/admin',
        expectedPermissionCode: 'Wnioski.PlatformaAdministracyjna.SprawyStudenta.PrzegladanieListy',
        children: null,
      },
      {
        label: 'requestsMyRequests',
        text: $localize`Moje podania`,
        module: 'wnioski/student',
        expectedPermissionCode: 'Wnioski.PlatformaStudenta.PodaniaStudenta.PrzegladanieListy',
        children: null,
      },
      {
        label: 'requestsMyCases',
        text: $localize`Moje sprawy`,
        module: 'wnioski/student',
        expectedPermissionCode: 'Wnioski.PlatformaStudenta.SprawyStudenta.PrzegladanieListy',
        children: null,
      },
    ],
  },
];

export const scholarshipsMenu: IMenuElement[] = [
  {
    label: 'scholarships',
    text: $localize`Stypendia`,
    module: 'stypendia',
    isRootElement: true,
    expectedPermissionCode: 'Stypendia',
    children: [
      {
        label: 'scholarshipsSeriesPrints',
        text: $localize`Wydruki seryjne`,
        module: 'stypendia',
        expectedPermissionCode: 'Stypendia.PlatformaAdministracyjna.WydrukiSeryjne.Lista',
        children: [
          {
            label: 'scholarshipsSeriesPrintsHistory',
            text: $localize`Historia wydruków seryjnych`,
            module: 'stypendia/admin',
            expectedPermissionCode: 'Stypendia.PlatformaAdministracyjna.WydrukiSeryjne.Lista',
            children: null,
          },
          {
            label: 'scholarshipsSeriesPrintsDecisions',
            text: $localize`Wydruk decyzji`,
            module: 'stypendia/admin',
            expectedPermissionCode: 'Stypendia.PlatformaAdministracyjna.WydrukiSeryjne.Decyzje.Lista',
            children: null,
          },
          {
            label: 'scholarshipsSeriesPrintsAppeals',
            text: $localize`Wydruk wezwań`,
            module: 'stypendia/admin',
            expectedPermissionCode: 'Stypendia.PlatformaAdministracyjna.WydrukiSeryjne.Wezwania.Lista',
            children: null,
          },
        ],
      },
      {
        label: 'scholarshipsDictionaries',
        text: $localize`Słowniki`,
        module: 'stypendia',
        expectedPermissionCode: 'Stypendia.PlatformaAdministracyjna.Slowniki.KonfiguracjaStypendiow.Lista',
        children: [
          {
            label: 'scholarshipsAchievementTypes',
            text: $localize`Typy osiągnięć`,
            module: 'stypendia/admin',
            expectedPermissionCode:
              'Stypendia.PlatformaAdministracyjna.Slowniki.StypendiumRektoraTypOsiagniecia.PrzegladanieListy',
            children: [
              {
                label: 'scholarshipsFreshmenAchievementTypes',
                text: $localize`Studenci pierwszego roku`,
                module: 'stypendia/admin',
                children: null,
                expectedPermissionCode:
                  'Stypendia.PlatformaAdministracyjna.Slowniki.StypendiumDlaStudentowPierwszegoRokuTypOsiacniecia.PrzegladanieListy',
              },
              {
                label: 'scholarshipsBestStudentsAchievementTypes',
                text: $localize`Najlepsi studenci`,
                module: 'stypendia/admin',
                children: null,
                expectedPermissionCode:
                  'Stypendia.PlatformaAdministracyjna.Slowniki.StypendiumRektoraTypOsiagniecia.PrzegladanieListy',
              },
            ],
          },
          {
            label: 'scholarshipsStudentCasesDefinitionConfig',
            text: $localize`Konfiguracja definicji spraw studenckich`,
            module: 'stypendia/admin',
            expectedPermissionCode: 'Stypendia.PlatformaAdministracyjna.DefinicjeSpraw.Lista',
            children: null,
          },
          {
            label: 'scholarshipsCasesConfig',
            text: $localize`Konfiguracja stypendiów`,
            module: 'stypendia/admin',
            expectedPermissionCode: 'Stypendia.PlatformaAdministracyjna.Slowniki.KonfiguracjeSpraw',
            children: [
              {
                label: 'scholarshipsForDisabledCasesConfig',
                text: $localize`Dla osób z niepełnosprawnością`,
                module: 'stypendia/admin',
                children: null,
                expectedPermissionCode:
                  'Stypendia.PlatformaAdministracyjna.Slowniki.KonfiguracjaWnioskowOStypendiumDlaNiepelnosprawnych.Lista',
              },
              {
                label: 'scholarshipsForBestStudentsCasesConfig',
                text: $localize`Stypendium rektorskie dla najlepszych studentów`,
                module: 'stypendia/admin',
                children: null,
                expectedPermissionCode:
                  'Stypendia.PlatformaAdministracyjna.Slowniki.KonfiguracjeSpraw.KonfiguracjeSprawyStypendiumRektoraDlaNajlepszychStudentow.Lista',
              },
              {
                label: 'scholarshipsForFirstAcademicYearStudentsCasesConfig',
                text: $localize`Stypendium rektorskie dla studentów I roku`,
                module: 'stypendia/admin',
                children: null,
                expectedPermissionCode:
                  'Stypendia.PlatformaAdministracyjna.Slowniki.KonfiguracjeSpraw.KonfiguracjeSprawyStypendiumRektoraDlaStudentowPierwszegoRoku.Lista',
              },
              {
                label: 'scholarshipsSocialConfig',
                text: $localize`Stypendium socjalne`,
                module: 'stypendia/admin',
                children: null,
                expectedPermissionCode:
                  'Stypendia.PlatformaAdministracyjna.Slowniki.KonfiguracjeSpraw.KonfiguracjeSprawyStypendiumSocjalne.Lista',
              },
              {
                label: 'scholarshipsCasesConfigBenefit',
                text: $localize`Zapomoga`,
                module: 'stypendia/admin',
                children: null,
                expectedPermissionCode:
                  'Stypendia.PlatformaAdministracyjna.Slowniki.KonfiguracjeSpraw.KonfiguracjeSprawyStypendiumOZapomoge.Lista',
              },
            ],
          },
          {
            label: 'scholarshipsApplicationsConfig',
            text: $localize`Konfiguracja wniosków`,
            module: 'stypendia/admin',
            expectedPermissionCode: 'Stypendia.PlatformaAdministracyjna.Slowniki.KonfiguracjaWnioskowOZapomoge.Lista',
            children: [
              {
                label: 'scholarshipsScholarshipsConfig',
                text: $localize`Wersje konfiguracji`,
                module: 'stypendia/admin',
                children: null,
                expectedPermissionCode: 'Stypendia.PlatformaAdministracyjna.Slowniki.KonfiguracjaStypendiow.Lista',
              },
              {
                label: 'scholarshipsForDisabledAppConfig',
                text: $localize`Dla osób z niepełnosprawnością`,
                module: 'stypendia/admin',
                children: null,
                expectedPermissionCode:
                  'Stypendia.PlatformaAdministracyjna.Slowniki.KonfiguracjaWnioskowOStypendiumDlaNiepelnosprawnych.Lista',
              },
              {
                label: 'scholarshipsBestStudentsAppConfig',
                text: $localize`Stypendium rektorskie dla najlepszych studentów`,
                module: 'stypendia/admin',
                children: null,
                expectedPermissionCode:
                  'Stypendia.PlatformaAdministracyjna.Slowniki.KonfiguracjaWnioskowOStypendiumRektora.Lista',
              },
              {
                label: 'scholarshipsFirstYearStudentsAppConfig',
                text: $localize`Stypendium rektorskie dla studentów I roku`,
                module: 'stypendia/admin',
                children: null,
                expectedPermissionCode:
                  'Stypendia.PlatformaAdministracyjna.Slowniki.KonfiguracjaWnioskowOStypendiumDlaStudentowPierwszegoRoku.Lista',
              },
              {
                label: 'scholarshipsSocialAppConfig',
                text: $localize`Stypendium socjalne`,
                module: 'stypendia/admin',
                children: null,
                expectedPermissionCode:
                  'Stypendia.PlatformaAdministracyjna.Slowniki.KonfiguracjaWnioskowOStypendiumSocjalne.Lista',
              },
              {
                label: 'scholarshipsAidAppConfig',
                text: $localize`Zapomoga`,
                module: 'stypendia/admin',
                children: null,
                expectedPermissionCode:
                  'Stypendia.PlatformaAdministracyjna.Slowniki.KonfiguracjaWnioskowOZapomoge.Lista',
              },
            ],
          },
          {
            label: 'scholarshipsLegalJustifications',
            text: $localize`Uzasadnienia prawne`,
            module: 'stypendia/admin',
            expectedPermissionCode: 'Stypendia.PlatformaAdministracyjna.Slowniki.UzasadnieniaPrawne',
            children: [
              {
                label: 'scholarshipsLegalJustificationsOfSubjectsDecision',
                text: $localize`Decyzje przedmiotowe`,
                module: 'stypendia/admin',
                expectedPermissionCode:
                  'Stypendia.PlatformaAdministracyjna.Slowniki.UzasadnieniaPrawne.DecyzjiPrzedmiotowej.Lista',
                children: null,
              },
              {
                label: 'scholarshipsLegalJustificationsOfInitRefusal',
                text: $localize`Odmowy wszczęcia`,
                module: 'stypendia/admin',
                expectedPermissionCode:
                  'Stypendia.PlatformaAdministracyjna.Slowniki.UzasadnieniaPrawne.OdmowyWszczecia.Lista',
                children: null,
              },
              {
                label: 'scholarshipsLegalJustificationsOfProceedingsRemission',
                text: $localize`Umorzenia postępowania`,
                module: 'stypendia/admin',
                expectedPermissionCode:
                  'Stypendia.PlatformaAdministracyjna.Slowniki.UzasadnieniaPrawne.UmorzeniaPostepowania.Lista',
                children: null,
              },
            ],
          },
          {
            label: 'scholarshipsAchievementsGroups',
            text: $localize`Grupy osiągnięć`,
            module: 'stypendia/admin',
            children: null,
            expectedPermissionCode: 'Stypendia.PlatformaAdministracyjna.Slowniki.GrupaOsiagniec.Lista',
          },
          {
            label: 'scholarshipsStudentStatuses',
            text: $localize`Konfiguracja statusów studenta`,
            module: 'stypendia/admin',
            children: null,
            expectedPermissionCode:
              'Stypendia.PlatformaAdministracyjna.ProgramStudiowStudentaStatusyDozwoloneSwiadczenia.Lista',
          },
          {
            label: 'scholarshipsDecisionMakers',
            text: $localize`Osoby decyzyjne`,
            module: 'stypendia/admin',
            expectedPermissionCode: 'Stypendia.PlatformaAdministracyjna.Slowniki.OsobyDecyzyjne.Lista',
            children: null,
          },
          {
            label: 'scholarshipsIncomeSources',
            text: $localize`Powody uzyskania dochodu`,
            module: 'stypendia/admin',
            children: null,
            expectedPermissionCode: 'Stypendia.PlatformaAdministracyjna.Slowniki.PowodyUzyskaniaDochodu.Lista',
          },
          {
            label: 'scholarshipsIncomeLossReasons',
            text: $localize`Powody utracenia dochodu`,
            module: 'stypendia/admin',
            children: null,
            expectedPermissionCode: 'Stypendia.PlatformaAdministracyjna.Slowniki.PowodyUtraceniaDochodu.Lista',
          },
          {
            label: 'scholarshipsDisabilityCauses',
            text: $localize`Przyczyny niepełnosprawności`,
            module: 'stypendia/admin',
            children: null,
            expectedPermissionCode:
              'Stypendia.PlatformaAdministracyjna.WniosekOStypendiumDlaNiepelnosprawnych.PrzyczynyNiepelnosprawnosci.PrzegladanieListy',
          },
          {
            label: 'scholarshipsDeductionsTypes',
            text: $localize`Rodzaje odliczeń`,
            module: 'stypendia/admin',
            children: null,
            expectedPermissionCode: 'Stypendia.PlatformaAdministracyjna.Slowniki.RodzajeOdliczen.Lista',
          },
          {
            label: 'scholarshipsUntaxedIncomeTypes',
            text: $localize`Typy dochodu nieopodatkowanego`,
            module: 'stypendia/admin',
            children: null,
            expectedPermissionCode:
              'Stypendia.PlatformaAdministracyjna.OswiadczenieODochodachWeryfikacja.TypDochoduNieopodatkowanego.PrzegladanieListy',
          },
          {
            label: 'scholarshipsStudentsCasesStatusVisibility',
            text: $localize`Widoczność statusów postępowania u studenta`,
            module: 'stypendia/admin',
            expectedPermissionCode: 'Stypendia.PlatformaAdministracyjna.StatusySprawyWidocznoscDlaStudenta.Lista',
            children: null,
          },
        ],
      },
      {
        label: 'scholarshipsDecisionResults',
        text: $localize`Wyniki decyzji stypendialnych`,
        module: 'stypendia/admin',
        expectedPermissionCode: 'Stypendia.PlatformaAdministracyjna.WynikiDecyzjiStypendialnej.Lista',
        children: null,
      },
      {
        label: 'scholarshipsPaymentsList',
        text: $localize`Listy wypłat`,
        module: 'stypendia/admin',
        expectedPermissionCode: 'Stypendia.PlatformaAdministracyjna.ListyWyplat.Lista',
        children: [
          {
            label: 'scholarshipsPaymentsListConfig',
            text: $localize`Konfiguracja`,
            module: 'stypendia/admin',
            expectedPermissionCode: 'Stypendia.PlatformaAdministracyjna.ListyWyplat.KonfiguracjeListyWyplat.Podglad',
            children: null,
          },
          {
            label: 'scholarshipsPaymentsListView',
            text: $localize`Lista`,
            module: 'stypendia/admin',
            expectedPermissionCode: 'Stypendia.PlatformaAdministracyjna.ListyWyplat.Lista',
            children: null,
          },
        ],
      },
      {
        label: 'scholarshipsIncomeStatementsList',
        text: $localize`Oświadczenia o dochodach`,
        module: 'stypendia/admin',
        expectedPermissionCode: 'Stypendia.PlatformaAdministracyjna.OswiadczenieODochodach.PrzegladanieListy',
        children: null,
      },
      {
        label: 'scholarshipsBestStudentsRanks',
        text: $localize`Rankingi najlepszych studentów`,
        module: 'stypendia/admin',
        expectedPermissionCode: 'Stypendia.PlatformaAdministracyjna.RankingNajlepszychStudentow.Lista',
        children: null,
      },
      {
        label: 'scholarshipsReports',
        text: $localize`Raporty`,
        module: 'stypendia/admin',
        expectedPermissionCode: 'Stypendia.PlatformaAdministracyjna.RankingNajlepszychStudentow.Lista', // TODO: zmiana permissiona gdy ten powstanie
        children: null,
      },
      {
        label: 'scholarshipsStudentsCases',
        text: $localize`Postępowania studentów`,
        module: 'stypendia/admin',
        expectedPermissionCode: 'Stypendia.PlatformaAdministracyjna.SprawyStudenta.PrzegladanieListy',
        children: null,
      },
      {
        label: 'scholarshipsApplicationsList',
        text: $localize`Wnioski`,
        module: 'stypendia/admin',
        expectedPermissionCode: 'Stypendia.PlatformaAdministracyjna.PodstawaWniosku.PrzegladanieListy',
        children: null,
      },
      {
        label: 'scholarshipsDashboard',
        text: $localize`Wykaz moich postępowań`,
        module: 'stypendia/admin',
        expectedPermissionCode: 'Stypendia.PlatformaAdministracyjna.SprawyStudenta.PrzegladanieListy',
        children: null,
      },
      {
        label: 'scholarshipsMyApplications',
        text: $localize`Moje wnioski`,
        module: 'stypendia/student',
        expectedPermissionCode: 'Stypendia.PlatformaStudenta.PodstawaWniosku.PrzegladanieListy',
        children: null,
      },
      {
        label: 'scholarshipsIncomeStatements',
        text: $localize`Oświadczenia o dochodach`,
        module: 'stypendia/student',
        expectedPermissionCode: 'Stypendia.PlatformaStudenta.OswiadczenieODochodach.PrzegladanieListy',
        children: null,
      },
      {
        label: 'scholarshipsFinishedFields',
        text: $localize`Ukończone kierunki`,
        module: 'stypendia/student',
        expectedPermissionCode: 'Stypendia.PlatformaStudenta.OswiadczenieOUkonczonychKierunkach.PrzegladanieListy',
        children: null,
      },
      {
        label: 'downloadsForStudents',
        text: $localize`Materiały do pobrania`,
        module: 'stypendia/student',
        expectedPermissionCode: 'RepozytoriumPlikow.PlatformaStudenta.Pliki.Lista',
        children: null,
      },
    ],
  },
];

export const financesMenu: IMenuElement[] = [
  {
    label: 'finances',
    text: $localize`Finanse`,
    module: 'finanse',
    isRootElement: true,
    expectedPermissionCode: 'Finanse',
    children: [
      {
        label: 'financesDictionaries',
        text: $localize`Słowniki`,
        module: 'finanse',
        expectedPermissionCode: 'Finanse.PracownikAdministracyjny.Slowniki',
        children: [
          {
            label: 'financesDiscounts',
            text: $localize`Bonifikaty`,
            module: 'finanse/administrator',
            children: null,
            expectedPermissionCode: 'Finanse.PracownikAdministracyjny.Slowniki.Bonifikaty.Lista',
          },
          {
            label: 'financesInstallmentsPlan',
            text: $localize`Plany ratalne`,
            module: 'finanse/administrator',
            children: null,
            expectedPermissionCode: 'Finanse.PracownikAdministracyjny.Slowniki.PlanyRatalne.Lista',
          },
          {
            label: 'financesProducts',
            text: $localize`Produkty`,
            module: 'finanse/administrator',
            children: null,
            expectedPermissionCode: 'Finanse.PracownikAdministracyjny.Slowniki.Produkty.Lista',
          },
          {
            label: 'financesCauses',
            text: $localize`Przyczyny operacji finansowych`,
            module: 'finanse/administrator',
            children: null,
            expectedPermissionCode: 'Finanse.PracownikAdministracyjny.Slowniki.Przyczyny.Lista',
          },
          {
            label: 'finanseRodzajeProduktow',
            text: $localize`Rodzaje produktów`,
            module: 'finanse/administrator',
            children: null,
            expectedPermissionCode: 'Finanse.PracownikAdministracyjny.Slowniki.RodzajProduktu.Lista',
          },
          {
            label: 'financesTypeOfAccountingAccounts',
            text: $localize`Rodzaje kont księgowych`,
            module: 'finanse/administrator',
            children: null,
            expectedPermissionCode: 'Finanse.PracownikAdministracyjny.Slowniki.RodzajeKontKsiegowych.Lista',
          },
        ],
      },
      {
        label: 'financesConfiguration',
        text: $localize`Konfiguracja`,
        module: 'finanse',
        expectedPermissionCode: 'Finanse.PracownikAdministracyjny.Konfiguracja',
        children: [
          {
            label: 'finanseKonfiguracjaUstawieniaOgolne',
            text: $localize`Ogólne`,
            module: 'finanse/administrator',
            children: null,
            expectedPermissionCode: 'Finanse.PracownikAdministracyjny.Konfiguracja.UstawieniaOgolne.Pobieranie',
          },
          {
            label: 'financesConfigurationPrice',
            text: $localize`Cenniki`,
            module: 'finanse/administrator',
            children: null,
            expectedPermissionCode: 'Finanse.PracownikAdministracyjny.Konfiguracja.Cennik.Lista',
          },
          {
            label: 'finanseKonfiguracjaOdsetki',
            text: $localize`Odsetki`,
            module: 'finanse/administrator',
            children: null,
            expectedPermissionCode: 'Finanse.PracownikAdministracyjny.KonfiguracjaOdsetki.Szczegoly',
          },
          {
            label: 'financesConfigurationCurrency',
            text: $localize`Waluty`,
            module: 'finanse/administrator',
            children: null,
            expectedPermissionCode: 'Finanse.PracownikAdministracyjny.Konfiguracja.Waluty.Lista',
          },
          {
            label: 'financesConfigurationTypesOfBankAccounts',
            text: $localize`Typy rachunków bankowych`,
            module: 'finanse/administrator',
            children: null,
            expectedPermissionCode: 'Finanse.PracownikAdministracyjny.Slowniki.TypyRachunkowBankowych.Lista',
          },
          {
            label: 'finanseKonfiguratorKalendarz',
            text: $localize`Kalendarz dni wolnych`,
            module: 'finanse/administrator',
            children: null,
            expectedPermissionCode: 'Finanse.PracownikAdministracyjny.Konfiguracja.Kalendarz.DniWolne.Lista',
          },
          {
            label: 'finanseKonfiguratorImporty',
            text: $localize`Schemat importu`,
            module: 'finanse/administrator',
            children: null,
            expectedPermissionCode: 'Finanse.PracownikAdministracyjny.Konfiguracja.Importy.Szczegoly',
          },
        ],
      },
      {
        label: 'financesImports',
        text: $localize`Importy`,
        module: 'finanse/administrator',
        children: null,
        expectedPermissionCode: 'Finanse.PracownikAdministracyjny.Importy.Lista',
      },
      {
        label: 'financesAnonim',
        text: $localize`Nierozliczone wpłaty`,
        module: 'finanse/administrator',
        children: null,
        expectedPermissionCode: 'Finanse.PracownikAdministracyjny.KontoAnonim.Wplaty.Lista',
      },
      {
        label: 'financesWplaty',
        text: $localize`Wpłaty`,
        module: 'finanse/administrator',
        children: null,
        expectedPermissionCode: 'Finanse.PracownikAdministracyjny.WszystkieWplaty.Lista',
      },
      {
        label: 'finanseStudentOplatyIWplaty',
        text: $localize`Opłaty i wpłaty`,
        module: 'finanse/student',
        children: null,
        expectedPermissionCode: 'Finanse.Student.Oplaty.Lista',
      },
      {
        label: 'financesInterestNotes',
        text: $localize`Noty odsetkowe`,
        module: 'finanse/administrator',
        children: null,
        expectedPermissionCode: 'Finanse.PracownikAdministracyjny.NotyOdsetkowe.Lista',
      },
      {
        label: 'financesReports',
        text: $localize`Raporty`,
        module: 'finanse/administrator',
        children: null,
        expectedPermissionCode: 'Finanse.PracownikAdministracyjny.Raporty',
      },
      {
        label: 'financesStudents',
        text: $localize`Studenci`,
        module: 'finanse/administrator',
        children: null,
        expectedPermissionCode: 'Finanse.PracownikAdministracyjny.ProgramStudiowStudentaDaneFinansowe.Lista',
      },
    ],
  },
];

export const filesRepositoryMenu: IMenuElement[] = [
  {
    label: 'filesRepository',
    text: $localize`Repozytorium plików`,
    module: 'repozytorium-plikow',
    isRootElement: true,
    expectedPermissionCode: 'RepozytoriumPlikow',
    children: [
      {
        label: 'filesRepositoryAdminFilesManagement',
        text: $localize`Zarządzanie plikami`,
        module: 'repozytorium-plikow/admin',
        children: null,
        expectedPermissionCode: 'RepozytoriumPlikow.PlatformaAdministracyjna.ZarzadzaniePlikami.Lista',
      },
      {
        label: 'filesRepositoryAdminFilesToDownload',
        text: $localize`Pliki do pobrania`,
        module: 'repozytorium-plikow/admin',
        children: null,
        expectedPermissionCode: 'RepozytoriumPlikow.PlatformaAdministracyjna.Pliki.Lista',
      },
      {
        label: 'filesRepositoryPracownikNaukowyFilesToDownload',
        text: $localize`Pliki do pobrania`,
        module: 'repozytorium-plikow/wykladowca',
        children: null,
        expectedPermissionCode: 'RepozytoriumPlikow.PlatformaPracownikaNaukowego.Pliki.Lista',
      },
      {
        label: 'filesRepositoryStudentFilesToDownload',
        text: $localize`Pliki do pobrania`,
        module: 'repozytorium-plikow/student',
        children: null,
        expectedPermissionCode: 'RepozytoriumPlikow.PlatformaStudenta.Pliki.Lista',
      },
    ],
  },
];

export const mojeDaneMenu: IMenuElement[] = [
  {
    label: 'mojeDane',
    text: $localize`Moje dane`,
    module: 'moje-dane',
    isRootElement: true,
    expectedPermissionCode: 'Studia.PlatformaStudenta.Osoby.DaneOsobowe',
    children: [
      {
        label: 'mojeDaneDaneOsobowe',
        text: $localize`Dane osobowe`,
        module: 'moje-dane/student',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaStudenta.Osoby.DaneOsobowe',
      },
      {
        label: 'mojeDaneDaneKontaktowe',
        text: $localize`Dane kontaktowe`,
        module: 'moje-dane/student',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaStudenta.Osoby.DaneOsobowe',
      },
      {
        label: 'mojeDaneNumeryAlbumow',
        text: $localize`Numery albumów`,
        module: 'moje-dane/student',
        children: null,
        expectedPermissionCode: 'Studia.PlatformaStudenta.Osoby.NumeryAlbumow',
      },
    ],
  },
];
